import "@lottiefiles/lottie-player";

import { setCookie, getCookie } from '../../../../../individual-restaurants/library/src/js/functions/cookies';

export const frontPageJs = () => {

	let areWeOnTheFrontPage = document.querySelector('#js__body.front-page');

	if(areWeOnTheFrontPage){

		//Do preloader
		let preloader = document.querySelector('#preloader')
		preloaderAnimation = document.querySelector("#preloader-animation");

		if(preloader){
			if(getCookie('preloaderState') == 'loaded' ){
				preloader.remove();
			}else{
				preloader.classList.add('playing');
				preloaderAnimation.addEventListener("complete", () => {
				  preloader.classList.add('animation-finished');
				  setCookie('preloaderState','loaded',1);
				  setTimeout(() => {
				  	preloader.classList.add('post-animation-complete');
				  },1250);
				});
			}
		}
		

		

		//Then initialise the cursor

		

	}
	

}